module.exports = __webpack_public_path__ + "static/media/close.e2e76428.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/CasePeriod/imgs/close.svg
// module id = 1657
// module chunks = 0